import { render, staticRenderFns } from "./SatisfactionRateList.vue?vue&type=template&id=56f2c27e&scoped=true&"
import script from "./SatisfactionRateList.vue?vue&type=script&lang=js&"
export * from "./SatisfactionRateList.vue?vue&type=script&lang=js&"
import style0 from "./SatisfactionRateList.vue?vue&type=style&index=0&id=56f2c27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f2c27e",
  null
  
)

export default component.exports